@if (prefix) {
  <div class="relative flex items-center">
    <div class="prefix absolute left-0 pl-5">{{ symbol }}</div>
    <input
      #number
      [(ngModel)]="value"
      type="number"
      id="amount"
      class="w-full rounded border border-neutral-800 px-5 py-4.5 pl-8 font-base md:w-448px"
      [max]="99"
      [min]="0"
      [maxlength]="2"
      (ngModelChange)="valueEmitter.emit(value)"
      [class.border-error-700]="error"
    />
  </div>
}
@if (suffix) {
  <div class="relative flex items-center relative">
    <input
      #number
      [(ngModel)]="value"
      type="number"
      id="weight"
      class="w-full rounded border border-neutral-800 px-5 py-4.5 pr-16 text-right font-base md:w-448px"
      [max]="99"
      [min]="0"
      [maxlength]="2"
      (ngModelChange)="valueEmitter.emit(value)"
      [class.border-error-700]="error"
    />
    <div class="suffix absolute right-0 pr-5">{{ symbol }}</div>
  </div>
}
